import React from 'react';
import { Col, Divider, Row } from 'antd';
import { TaskDTO } from '../../../hooks/types';
import { TaskContainer, Title, Topic } from './style';

type ActionPlanTaskProps = {
	task: TaskDTO;
	length: number;
};

export const ActionPlanTask: React.FC<ActionPlanTaskProps> = ({ task, length }) => {
	function hasDivider() {
		return length > 0;
	}

	return (
		<TaskContainer>
			<Row justify="space-between">
				<Col
					span={24}
					style={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis'
					}}
				>
					<Topic>•</Topic>
					<Title>{task.description}</Title>
				</Col>
			</Row>
			{hasDivider() && <Divider style={{ margin: '0.25rem 0' }} />}
		</TaskContainer>
	);
};
